export default {
  labels: {
    field: 'Field'
  },

  directions: {
    ASC: 'Ascending',
    DESC: 'Descending'
  }
}
